import { render, staticRenderFns } from "./premiumoverlay.component.html?vue&type=template&id=40b9b5ec&scoped=true&"
import script from "./premiumoverlay.component.ts?vue&type=script&lang=ts&"
export * from "./premiumoverlay.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b9b5ec",
  null
  
)

export default component.exports